// extracted by mini-css-extract-plugin
export default {"emptyWrapper":"styles_empty-wrapper__GG1OA","fileIcon":"styles_file-icon__6nZ-P","small":"styles_small__cWzYb"};